function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './DefaultCards.css';
import React from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { get } from '../../../utils';
import { convertToAnalyticObject } from '../../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import RouterLink from '../../atoms/RouterLink';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { isNotNil } from '../../../utils/IsNil';
var Cards = function Cards(_ref) {
  var item = _ref.item,
    params = _ref.params,
    eventsAnalytics = _ref.eventsAnalytics;
  var sitecoreContext = useSitecoreContext();
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var cardIconSrc = get(item, 'cardIcon.jss.value.src');
  var svgIcon = get(item, 'cardIconCode.jss.value');
  var cardIconAlt = get(item, 'cardIcon.jss.value.alt');
  var hasTitle = Boolean(get(item, 'title.jss.value'));
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var source = get(item, 'tag.jss.value');
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var renderLink = function renderLink() {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    var preTitle = hasTitle ? "".concat(get(item, 'title.jss.value'), " | ") : '';
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement("p", {
      className: "textSourceLink"
    }, source), /*#__PURE__*/React.createElement(RouterLink, {
      className: "general-card-button",
      href: item.ctaLink.jss.value.href,
      title: "".concat(preTitle).concat(ctaLabel),
      linktype: "external",
      openInSameTab: true,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['discoverMoreLinkAnalytics'], params), [item.title.jss.value, item.ctaLabel.jss.value]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel)));
  };
  return /*#__PURE__*/React.createElement("div", null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon",
    "data-cy": "general-card-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-box theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iconCircle"
  }, isNotNil(svgIcon) && svgIcon.includes("svg") ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svgIcon
    },
    className: "h__icon"
  }) : /*#__PURE__*/React.createElement("img", {
    className: "h__icon",
    src: BASE_URL + cardIconSrc,
    alt: cardIconAlt
  })), hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, renderLink())));
};
var DefaultCards = function DefaultCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var classItemsContainerMap = {
    2: "twoItemsContainer",
    3: "threeItemsContainer",
    4: "fourItemsContainer"
  };
  var classItemWidthMap = {
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };
  var cardsProps = {
    params: {
      eventCat: params.eventCat,
      eventName: params.eventName,
      eventAct: params.eventAct,
      ColorHex: params.ColorHex,
      BackgroundColorHex: params.BackgroundColorHex
    }
  };
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "itemWidth ".concat(classItemWidthMap[items.length]),
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: item.id
      }, /*#__PURE__*/React.createElement(Cards, _extends({}, cardsProps, {
        item: item,
        eventsAnalytics: eventsAnalytics
      })));
    });
  };
  var renderItems04 = function renderItems04() {
    if (items.length <= 1) {
      console.warn("provided ".concat(items.length, " card but requires 2 or more cards"));
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classItemsContainerMap[items.length]
    }, renderItems());
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "M07_default"
  }, defaultCardsHasTitle && items.length < 5 ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, items.length < 5 ? renderItems04() : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(defaultCardsHasTitle ? 'card__head' : 'cardHeadOnlyWithPagination')
    }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['previous']);
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextPrevAnalytics'], params), ['next']);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1101
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1100,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navigationBubblesAnalytics'], params));
    })));
  }) : null);
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    className = _ref4.className,
    style = _ref4.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var generalItemsContainer = "\n  display: flex;\n  gap: 10px 20px;\n";
var commonStyles = "c17tvy2l";
var ltrStyles = "l1n554ic";
var rtlStyles = "r1pnbox7";
export { DefaultCards };